import {
  Directive,
  EventEmitter,
  Output,
  HostListener
} from '@angular/core';

@Directive({
  selector: '[scrollSpy]'
})
export class ScrollSpyDirective {
  @Output() public navSize = new EventEmitter<number>();

  constructor() { }

  @HostListener('window:scroll', ['$event'])
  onScroll(event: any) {

    const Ypos = 0 - event.target.scrollingElement.getBoundingClientRect().y;
    if (Ypos === 0) {
      this.navSize.emit(0);
    }

    if (Ypos > 1 && Ypos < 100) {
      this.navSize.emit(Ypos);
    }

    if (Ypos > 100) {
      this.navSize.emit(100);
    }
  }
}
